"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridLegacySelectExampleCodeSegments = exports.GKDataGridLegacySelectExample = void 0;
var React = __importStar(require("react"));
var gds_ux_components_1 = require("@granular/gds-ux-components");
var components_1 = require("../../components");
var tableData = [
    { id: 1, name: "Cupiditate Sed", acres: 320.12, crop: "Corn" },
    { id: 2, name: "Laboriosam Reiciendis", acres: 120.45, crop: "Soybeans" },
    { id: 3, name: "Minima Dignissimos Porro", acres: 45.22, crop: "Soybeans" },
    { id: 4, name: "Molestias Aspernatur", acres: 312.19, crop: "Corn" },
    { id: 5, name: "Nostrum Dolorum Est", acres: 84.14, crop: "Corn" },
    { id: 6, name: "Molestias Consequuntur", acres: 88.46, crop: "Corn" },
    { id: 7, name: "Vero Officia", acres: 210.01, crop: "Winter Wheat" },
    { id: 8, name: "Quam Eligendi", acres: 48.29, crop: "Corn" },
    { id: 9, name: "Distinctio", acres: 98.3, crop: "Soybeans" },
    { id: 10, name: "Ullam a Maiores", acres: 102.18, crop: "Winter Wheat" },
];
var tableColumns = [
    {
        Header: "Field Name",
        accessor: "name",
    },
    {
        Header: "Acres",
        accessor: "acres",
    },
    {
        Header: "Crop Type",
        accessor: "crop",
    },
];
var GKDataGridLegacySelectExample = function () {
    var _a = React.useState([tableData[1]]), selected = _a[0], setSelected = _a[1];
    return (React.createElement(gds_ux_components_1.Row, null,
        React.createElement(gds_ux_components_1.Col, { md: 9 },
            React.createElement(components_1.GKDataGridLegacy, { gridClassName: "-highlight", columns: tableColumns, data: tableData, selection: selected, onSelection: setSelected, expandable: true, SubComponent: function (row) { return (React.createElement("div", null,
                    React.createElement("h2", { className: "p-2 m-0" },
                        "This is a subcomponent for ",
                        row.original.name,
                        "."))); } })),
        React.createElement(gds_ux_components_1.Col, { md: 3 },
            React.createElement("h3", { className: "mt-3" }, "Selected Items:"),
            React.createElement("ul", null, selected.map(function (d) { return (React.createElement("li", { key: d.id }, d.name)); })))));
};
exports.GKDataGridLegacySelectExample = GKDataGridLegacySelectExample;
// </copy>
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.GKDataGridLegacySelectExampleCodeSegments = ["interface Data {\n  id: number;\n  name: string;\n  acres: number;\n  crop: string;\n}\nconst tableData: Data[] = [\n  { id: 1, name: \"Cupiditate Sed\", acres: 320.12, crop: \"Corn\" },\n  { id: 2, name: \"Laboriosam Reiciendis\", acres: 120.45, crop: \"Soybeans\" },\n  { id: 3, name: \"Minima Dignissimos Porro\", acres: 45.22, crop: \"Soybeans\" },\n  { id: 4, name: \"Molestias Aspernatur\", acres: 312.19, crop: \"Corn\" },\n  { id: 5, name: \"Nostrum Dolorum Est\", acres: 84.14, crop: \"Corn\" },\n  { id: 6, name: \"Molestias Consequuntur\", acres: 88.46, crop: \"Corn\" },\n  { id: 7, name: \"Vero Officia\", acres: 210.01, crop: \"Winter Wheat\" },\n  { id: 8, name: \"Quam Eligendi\", acres: 48.29, crop: \"Corn\" },\n  { id: 9, name: \"Distinctio\", acres: 98.3, crop: \"Soybeans\" },\n  { id: 10, name: \"Ullam a Maiores\", acres: 102.18, crop: \"Winter Wheat\" },\n];\nconst tableColumns: Column[] = [\n  {\n    Header: \"Field Name\",\n    accessor: \"name\",\n  },\n  {\n    Header: \"Acres\",\n    accessor: \"acres\",\n  },\n  {\n    Header: \"Crop Type\",\n    accessor: \"crop\",\n  },\n];\nexport const GKDataGridLegacySelectExample: React.FC = () => {\n  const [selected, setSelected] = React.useState<Data[]>([tableData[1]]);\n  return (\n    <Row>\n      <Col md={9}>\n        <GKDataGridLegacy\n          gridClassName=\"-highlight\"\n          columns={tableColumns}\n          data={tableData}\n          selection={selected}\n          onSelection={setSelected}\n          expandable={true}\n          SubComponent={(row: RowInfo): JSX.Element => (\n            <div>\n              <h2 className=\"p-2 m-0\">\n                This is a subcomponent for {row.original.name}.\n              </h2>\n            </div>\n          )}\n        />\n      </Col>\n      <Col md={3}>\n        <h3 className=\"mt-3\">Selected Items:</h3>\n        <ul>\n          {selected.map((d) => (\n            <li key={d.id}>{d.name}</li>\n          ))}\n        </ul>\n      </Col>\n    </Row>\n  );\n};"];
/* eslint-enable prettier/prettier */
